import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Video } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';
const BACKEND = process.env.REACT_APP_BACKEND_URL;
const resolveImg = (url) => (url && url.startsWith('/api') ? `${BACKEND}${url}` : url);

const MediaPicker = ({ open, onClose, type = 'image', onSelect }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    const load = async () => {
      setLoading(true);
      try {
        const res = await axios.get(`${API_URL}/media-library/${type === 'image' ? 'images' : 'videos'}`);
        setItems(res.data || []);
      } catch (e) {
        toast.error('No se pudo cargar la biblioteca');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [open, type]);

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto" data-testid="media-picker">
        <DialogHeader>
          <DialogTitle>{type === 'image' ? 'Biblioteca de imágenes' : 'Vídeos usados anteriormente'}</DialogTitle>
        </DialogHeader>
        {loading ? (
          <div className="py-10 text-center text-slate-400">Cargando...</div>
        ) : items.length === 0 ? (
          <div className="py-10 text-center text-slate-400">Aún no hay {type === 'image' ? 'imágenes' : 'vídeos'} para reutilizar.</div>
        ) : type === 'image' ? (
          <div className="grid grid-cols-3 sm:grid-cols-4 gap-3">
            {items.map((it) => (
              <button
                key={it.filename} type="button"
                onClick={() => { onSelect(it.url); onClose(); }}
                className="group border border-slate-200 rounded-lg overflow-hidden hover:ring-2 hover:ring-[#004E89] transition"
                data-testid="media-picker-item" title={it.original_name || ''}
              >
                <img src={resolveImg(it.url)} alt={it.original_name || ''} className="w-full h-24 object-cover" />
              </button>
            ))}
          </div>
        ) : (
          <div className="space-y-2">
            {items.map((it, idx) => (
              <button
                key={idx} type="button"
                onClick={() => { onSelect(it.url); onClose(); }}
                className="w-full flex items-center gap-3 text-left px-3 py-2 rounded-lg border border-slate-200 hover:border-[#004E89] hover:bg-slate-50 transition"
                data-testid="media-picker-item"
              >
                <Video className="w-4 h-4 text-[#004E89] flex-shrink-0" />
                <span className="text-sm text-slate-700 truncate">{it.label || it.url}</span>
              </button>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default MediaPicker;
